export default function Footer() {
  return (
    <footer className="bg-studio-black border-t border-studio-border py-12 px-6 md:px-12 lg:px-16">
      <div className="w-full">
        <div className="flex flex-col lg:flex-row items-start lg:items-center justify-between gap-8 mb-10">
          {/* Logo */}
          <div className="flex items-center gap-2">
            <div className="w-8 h-8 flex items-center justify-center">
              <i className="ri-equalizer-line text-studio-silver text-xl" />
            </div>
            <span className="font-bebas text-studio-silver text-2xl md:text-3xl tracking-wider">
              TROUBLE <span className="text-studio-muted">STUDIO</span>
            </span>
          </div>

          {/* Nav links */}
          <div className="flex flex-wrap gap-6 md:gap-8">
            {[
              { label: '레슨', href: '#lessons' },
              { label: '소개', href: '#about' },
              { label: '커리큘럼', href: '#curriculum' },
              { label: '가격', href: '#pricing' },
              { label: '문의', href: '#inquiry' },
            ].map((link) => (
              <button
                key={link.label}
                onClick={() => {
                  const el = document.querySelector(link.href);
                  if (el) el.scrollIntoView({ behavior: 'smooth' });
                }}
                className="text-studio-gray hover:text-studio-silver font-sans text-sm transition-colors cursor-pointer"
              >
                {link.label}
              </button>
            ))}
          </div>

          {/* Social */}
          <div className="flex gap-3">
            {[
              { icon: 'ri-instagram-line', label: 'Instagram', href: 'https://www.instagram.com/baybrick_/' },
              { icon: 'ri-youtube-line', label: 'YouTube', href: '#' },
              { icon: 'ri-kakao-talk-fill', label: 'KakaoTalk', href: 'http://pf.kakao.com/_phLXb/chat' },
            ].map((s) => (
              <a
                key={s.label}
                href={s.href}
                target="_blank"
                rel="noopener noreferrer"
                aria-label={s.label}
                className="w-10 h-10 flex items-center justify-center border border-studio-border rounded-full hover:border-studio-silver hover:text-studio-silver transition-colors cursor-pointer"
              >
                <i className={`${s.icon} text-studio-gray text-lg`} />
              </a>
            ))}
          </div>
        </div>

        {/* Bottom bar */}
        <div className="border-t border-studio-border pt-6 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-studio-muted font-sans text-xs">
            © 2026 TROUBLE STUDIO. All rights reserved.
          </p>
          <div className="flex gap-6">
            <span className="text-studio-muted font-sans text-xs">개인정보처리방침</span>
            <span className="text-studio-muted font-sans text-xs">이용약관</span>
          </div>
        </div>
      </div>
    </footer>
  );
}